import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const SessionExpiredModal = ({ open, onLoginAgain, onCancel, isExpiringSoon }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onCancel?.();
        }
      }}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          p: 1,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 4, pb: 2 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: isExpiringSoon ? 'rgba(255, 152, 0, 0.1)' : 'rgba(211, 47, 47, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          {isExpiringSoon ? (
            <WarningRoundedIcon sx={{ fontSize: 32, color: '#FF9800' }} />
          ) : (
            <SecurityRoundedIcon sx={{ fontSize: 32, color: '#D32F2F' }} />
          )}
        </Box>

        <DialogTitle sx={{ fontWeight: 800, fontSize: '1.5rem', textAlign: 'center', pb: 1 }}>
          {isExpiringSoon ? 'Session Expiring Soon' : 'Session Expired'}
        </DialogTitle>

        <DialogContent sx={{ textAlign: 'center' }}>
          <DialogContentText sx={{ color: '#475569', fontSize: '0.95rem', lineHeight: 1.6 }}>
            {isExpiringSoon
              ? 'Your session will expire in approximately 5 minutes for security reasons. Would you like to continue working?'
              : 'Your login session has expired for security reasons. Please sign in again to continue using The Skill Genie.'}
          </DialogContentText>
        </DialogContent>
      </Box>

      <DialogActions sx={{ px: 4, pb: 4, pt: 1, flexDirection: 'column', gap: 1.5 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={onLoginAgain}
          sx={{
            py: 1.5,
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '1rem',
            bgcolor: '#6C3BFF',
            '&:hover': {
              bgcolor: '#5020E0',
            },
            boxShadow: '0 4px 12px rgba(108,59,255,0.25)',
          }}
        >
          {isExpiringSoon ? 'Continue Working' : 'Login Again'}
        </Button>
        <Button
          fullWidth
          variant="text"
          onClick={onCancel}
          sx={{
            py: 1.2,
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            color: '#64748B',
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.04)',
            },
          }}
        >
          {isExpiringSoon ? 'Logout' : 'Cancel'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;
